// extracted by mini-css-extract-plugin
export default {"list":"SelectList_list__ZrApS"};